import React from 'react';
import { useIntl } from 'umi';

import SwitchCollapse from '@/pages/datalab/components/SwitchCollapse';
import TipContext from '@home/components/TipContext';

interface ICollapseFilterSectionProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const CollapseFilterSection: React.FC<ICollapseFilterSectionProps> = (props) => {
  const { open, onOpenChange } = props;
  const { formatMessage } = useIntl();

  const title = (
    <div className="dbl-filter-setUp-title">
      {formatMessage({ id: 'dbl_filter_collapse_expand_filter' })}
      <TipContext
        className="dbl-filter-setUp-title-icon"
        tipText={formatMessage({ id: 'dbl_filter_collapse_expand_filter_tips' })}
      />
    </div>
  );

  return (
    <SwitchCollapse
      title={title}
      defaultOpen={open}
      onOpenChange={onOpenChange}
    />
  );
};

export default CollapseFilterSection;
